// Unitest_Error.js
import "./IvError.css";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Modal, Table, Button } from "react-bootstrap";
import { getIvDataIndex, getIvFieldValue } from "../../utils/ivErrorDataUtils";

const UnitestOperationStatusData = {
  title: "Address 21 인버터 동작 상태",
  rows: [
    { bit: "Bit0", name: "Run", desc: "인버터 운전 시작하여 발전" },
    { bit: "Bit1", name: "SqStart", desc: "인버터 발전 시작 전 시퀀스 진행" },
    { bit: "Bit2", name: "Ready", desc: "인버터 운전 전원 입력 대기" },
    { bit: "Bit3", name: "Run_Key", desc: "인버터 RUN/STOP KEY RUN 상태" },
    { bit: "Bit4", name: "MC1 투입", desc: "인버터 MC1 Close 상태" },
    { bit: "Bit5", name: "MC2 투입", desc: "인버터 MC2 Close 상태" },
    { bit: "Bit6", name: "-", desc: "-" },
    { bit: "Bit7", name: "-", desc: "-" },
    { bit: "Bit8", name: "Inv_Run", desc: "DC-AC IGBT Run 상태" },
    { bit: "Bit9", name: "Conv_Run", desc: "DC-DC IGBT Run 상태" },
    { bit: "Bit10", name: "일반제어모드", desc: "일반 제어모드(0) 단위 역률제어" },
    { bit: "Bit11", name: "역률제어모드", desc: "역률 제어모드(2) 역률 지정받을 시" },
    { bit: "Bit12", name: "전압제어모드", desc: "전압 제어모드(5) 능동전압제어 지원받을 시" },
    { bit: "Bit13", name: "-", desc: "-" },
    { bit: "Bit14", name: "-", desc: "-" },
    { bit: "Bit15", name: "-", desc: "-" },
  ],
};

const UnitestHardwareErrorData = {
  title: "Address 22 하드웨어 에러",
  rows: [
    { bit: "Bit0", name: "DCOV", desc: "인버터 boost 과전압 발생" },
    { bit: "Bit1", name: "DCOC", desc: "인버터 boost 과전류 발생" },
    { bit: "Bit2", name: "ACOC", desc: "인버터 출력 과전류 발생" },
    { bit: "Bit3", name: "InvF", desc: "DC-AC IGBT 에러 발생" },
    { bit: "Bit4", name: "ConvF", desc: "DC-DC IGBT 에러 발생" },
    { bit: "Bit5", name: "InvOTH", desc: "DC-AC IGBT 과온 발생" },
    { bit: "Bit6", name: "ConvOTH", desc: "DC-DC IGBT 과온 발생" },
    { bit: "Bit7", name: "InOTH", desc: "인버터 내부 과온 발생" },
    { bit: "Bit8", name: "MCloseF", desc: "인버터 MC close 불량 발생" },
    { bit: "Bit9", name: "MCOpenF", desc: "인버터 MC open 불량 발생" },
    { bit: "Bit10", name: "-", desc: "-" },
    { bit: "Bit11", name: "-", desc: "-" },
    { bit: "Bit12", name: "SMPSF", desc: "인버터 내부 시스템 전원 이상 발생" },
    { bit: "Bit13", name: "COMMF", desc: "인버터 내부 시스템 통신 이상 발생" },
    { bit: "Bit14", name: "-", desc: "-" },
    { bit: "Bit15", name: "HWF", desc: "HW 에러 검출" },
  ],
};

const UnitestSoftwareErrorData = {
  title: "Address 23 소프트웨어 에러",
  rows: [
    { bit: "Bit0", name: "Synch", desc: "계통 전원 차단으로 단독운전 상태 발생" },
    { bit: "Bit1", name: "ACOV", desc: "인버터 출력 전원 과전압 발생" },
    { bit: "Bit2", name: "ACLV", desc: "인버터 출력 전원 저전압 발생" },
    { bit: "Bit3", name: "ACOF", desc: "인버터 출력 전원 주파수 상승 검출" },
    { bit: "Bit4", name: "ACLF", desc: "인버터 출력 전원 주파수 하강 검출" },
    { bit: "Bit5", name: "PVOV", desc: "모듈 입력 전원 과전압 발생" },
    { bit: "Bit6", name: "PVLV", desc: "모듈 입력 전원 저전압 발생" },
    { bit: "Bit7", name: "DCOV", desc: "인버터 Boost 과전압 발생" },
    { bit: "Bit8", name: "DCLV", desc: "인버터 Boost 저전압 발생" },
    { bit: "Bit9", name: "ACOC", desc: "인버터 출력 전원 과전류 발생" },
    { bit: "Bit10", name: "PVOC", desc: "모듈 입력 전원 과전류 발생" },
    { bit: "Bit11", name: "DCOC", desc: "인버터 Boost 전원 과전류 발생" },
    { bit: "Bit12", name: "-", desc: "-" },
    { bit: "Bit13", name: "-", desc: "-" },
    { bit: "Bit14", name: "-", desc: "-" },
    { bit: "Bit15", name: "-", desc: "-" },
  ],
};

const parseBitFlags16 = (value) => {
  const flags = {};

  if (typeof value !== "number") return flags;

  for (let i = 0; i < 16; i++) {
    flags[`Bit${i}`] = (value & (1 << i)) !== 0;
  }

  return flags;
};

const toHex4 = (value) => {
  if (typeof value !== "number") return "0000";
  return value.toString(16).toUpperCase().padStart(4, "0");
};

// Address 22, 23 전용
// 에러 비트는 하나라도 ON이면 비정상
const isErrorBitsAbnormal = (value) => {
  if (typeof value !== "number") return false;
  return value !== 0;
};

// Address 21 전용
// 동작 상태는 0이 아니라고 비정상이 아님
const isOperationStatusAbnormal = (value) => {
  if (typeof value !== "number") return false;

  const bits = parseBitFlags16(value);

  const isNormalRunning =
    bits.Bit0 && // Run
    bits.Bit3 && // Run_Key
    bits.Bit4 && // MC1 투입
    bits.Bit8 && // Inv_Run
    bits.Bit9; // Conv_Run

  return !isNormalRunning;
};

const getFallbackErrorValue = (ivData, SelInverter, directKey, errorIndex) => {
  const directValue = getIvFieldValue(ivData, directKey, SelInverter);

  if (typeof directValue === "number") {
    return directValue;
  }

  const errorValue = getIvFieldValue(ivData, "Error", SelInverter);

  if (Array.isArray(errorValue) && typeof errorValue[errorIndex] === "number") {
    return errorValue[errorIndex];
  }

  return directValue;
};

const Unitest_Error = ({ SelInverter }) => {
  const ivData = useSelector((state) => state.ivData || {});

  const [showOperationModal, setShowOperationModal] = useState(false);
  const [showHardwareModal, setShowHardwareModal] = useState(false);
  const [showSoftwareModal, setShowSoftwareModal] = useState(false);

  const dataIndex = getIvDataIndex(ivData, SelInverter);

  /*
    unitest_inv.py 저장 기준:
    Address 21 -> Inverter_State_Bits
    Address 22 -> Hardware_Error_Bits
    Address 23 -> Software_Error_Bits

    fallback:
    Error[2] -> 동작 상태
    Error[0] -> 하드웨어 에러
    Error[1] -> 소프트웨어 에러
  */
  const operationStatus = getFallbackErrorValue(
    ivData,
    SelInverter,
    "Inverter_State_Bits",
    2
  );

  const hardwareError = getFallbackErrorValue(
    ivData,
    SelInverter,
    "Hardware_Error_Bits",
    0
  );

  const softwareError = getFallbackErrorValue(
    ivData,
    SelInverter,
    "Software_Error_Bits",
    1
  );

  const operationBits = parseBitFlags16(operationStatus);
  const hardwareBits = parseBitFlags16(hardwareError);
  const softwareBits = parseBitFlags16(softwareError);

  const operationAbnormal = isOperationStatusAbnormal(operationStatus);
  const hardwareAbnormal = isErrorBitsAbnormal(hardwareError);
  const softwareAbnormal = isErrorBitsAbnormal(softwareError);

  const renderBitModal = (show, onHide, modalData, bitFlags, value) => {
    return (
      <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {modalData.title} / 현재값: {value ?? 0} (0x{toHex4(value)})
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Table striped bordered size="sm">
            <thead>
              <tr>
                <th>BIT</th>
                <th>내용</th>
                <th>설명</th>
                <th>상태</th>
              </tr>
            </thead>
            <tbody>
              {modalData.rows.map((row, idx) => {
                const isActive = bitFlags[row.bit];

                return (
                  <tr key={idx} className={isActive ? "active-row" : ""}>
                    <td>{row.bit}</td>
                    <td>{row.name}</td>
                    <td>{row.desc}</td>
                    <td>{isActive ? "ON" : "OFF"}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            닫기
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  if (dataIndex === -1) {
    return <div className="status-list-container">인버터를 선택하세요.</div>;
  }

  return (
    <div className="status-list-container">
      <div className="status-list">
        <div className="status-item">
          <span className="status-value">
            Address 21 인버터 동작 상태: {operationStatus ?? 0} (
            0x{toHex4(operationStatus)})
          </span>
          <button onClick={() => setShowOperationModal(true)}>
            <span className={operationAbnormal ? "blinking-icon" : ""}>
              {operationAbnormal ? "🔴" : "🟢"}
            </span>
          </button>
        </div>

        <div className="status-item">
          <span className="status-value">
            Address 22 하드웨어 에러: {hardwareError ?? 0} (
            0x{toHex4(hardwareError)})
          </span>
          <button onClick={() => setShowHardwareModal(true)}>
            <span className={hardwareAbnormal ? "blinking-icon" : ""}>
              {hardwareAbnormal ? "🔴" : "🟢"}
            </span>
          </button>
        </div>

        <div className="status-item">
          <span className="status-value">
            Address 23 소프트웨어 에러: {softwareError ?? 0} (
            0x{toHex4(softwareError)})
          </span>
          <button onClick={() => setShowSoftwareModal(true)}>
            <span className={softwareAbnormal ? "blinking-icon" : ""}>
              {softwareAbnormal ? "🔴" : "🟢"}
            </span>
          </button>
        </div>
      </div>

      {showOperationModal &&
        renderBitModal(
          showOperationModal,
          () => setShowOperationModal(false),
          UnitestOperationStatusData,
          operationBits,
          operationStatus
        )}

      {showHardwareModal &&
        renderBitModal(
          showHardwareModal,
          () => setShowHardwareModal(false),
          UnitestHardwareErrorData,
          hardwareBits,
          hardwareError
        )}

      {showSoftwareModal &&
        renderBitModal(
          showSoftwareModal,
          () => setShowSoftwareModal(false),
          UnitestSoftwareErrorData,
          softwareBits,
          softwareError
        )}
    </div>
  );
};

export default Unitest_Error;